// extracted by mini-css-extract-plugin
export default {"container":"AboutUs_container__jX4b5","heading":"AboutUs_heading__aXdZu","text":"AboutUs_text__sTZbi"};